<template>
  <div class="popup hide-for-print">
    <transition name="fade">
      <div class="popup__wrap" v-if="visible === true" @click.stop="close()">
        <div class="popup-bg">
        <div @click.stop="close()" class="popup__wrap__close">
          <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><line class="cls-1" x1="0" y1="0" x2="25" y2="25"/><line class="cls-1" x1="25" y1="0" x2="0" y2="25"/></svg>
        </div>
          <div class="popup__wrap__content">
            <h3 class="popup__wrap__content__title" v-if="title !== ''">{{ title }}</h3>
            <div class="popup__wrap__content__body" v-html="content"></div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js'

export default {
  name: 'popup',
  data () {
    return {
      title: '',
      content: '',
      visible: false
    }
  },
  created () {
    EventBus.$on('popup.open', (title, content) => {
      this.title = title
      this.content = content
      this.open()
    })
    EventBus.$on('popup.close', () => {
      this.close()
    })
  },
  destroyed () {
    // Remove event handlers
    EventBus.$off('popup.open')
    EventBus.$off('popup.close')
  },
  methods: {
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  $popup-times-size: 20px;

  .popup__wrap{
    align-items: center;
    background: transparentize($blue, 0.6);
    bottom: 0;
    display: flex; -js-display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 500
  }

  .popup__wrap__close{
    cursor: pointer;
    height: $popup-times-size;
    position: absolute;
    right: -35px;
    top: -35px;

    .cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}
  }

  .popup-bg{
    background: $blue;
    box-shadow: 0 3px 20px 0 transparentize($gray-darkest, 0.8);
    color: $white;
    padding: 2em;
    position: relative;
    max-width: 400px;
  }

  .popup__wrap__content__title{
    color: $white;
    font-family: $fontfamily-sans-serif;
    font-weight: bold;
    font-size: 16px;
    margin: 0 0 1em 0;
    padding: 0;
  }

  .popup__wrap__content__body{}

</style>



// WEBPACK FOOTER //
// src/components/shared/misc/Popup.vue